module.exports = __webpack_public_path__ + "img/amazulu-logo-icon.135b5f96.png";